import {FaWordpress  } from 'react-icons/fa'
import {AiFillGithub,AiFillLinkedin,AiOutlineInstagram } from 'react-icons/ai'

const data = [
    {id: 1, link: 'https://www.linkedin.com/in/jayesh-solanki-dev/', icon: <AiFillLinkedin/>},
    {id: 2, link: 'https://www.instagram.com/jayeshsolanki_1307/', icon: <AiOutlineInstagram/>},
    {id: 3, link: 'https://profiles.wordpress.org/imjayeshwp/', icon: <FaWordpress/>},
    {id: 4, link: 'https://github.com/jayeshsolanki1307', icon: <AiFillGithub/>}
]

export default data